import RatgeberTemplate from "@/components/RatgeberTemplate";
import { getRatgeberBySlug } from "@/data/ratgeberData";
import Footer from "@/components/Footer";

const RatgeberHusten = () => {
  const content = getRatgeberBySlug("husten");
  if (!content) return null;

  return (
    <>
      <RatgeberTemplate content={content} />
      <Footer />
    </>
  );
};

export default RatgeberHusten;
